import React from 'react';
import { Box, Typography, Link, Paper } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

const formatFileSize = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const isImageType = (mimeType) =>
  mimeType && mimeType.startsWith('image/');

const isPdfType = (mimeType) =>
  mimeType === 'application/pdf';

const getFileIcon = (mimeType) => {
  if (isImageType(mimeType)) return <ImageOutlinedIcon sx={{ fontSize: 18, color: '#1A73E8' }} />;
  if (isPdfType(mimeType)) return <PictureAsPdfOutlinedIcon sx={{ fontSize: 18, color: '#F43F5E' }} />;
  return <InsertDriveFileOutlinedIcon sx={{ fontSize: 18, color: '#1A73E8' }} />;
};

const ChatAttachment = ({ attachment }) => {
  const { fileName, fileUrl, fileSize, mimeType } = attachment;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1,
        mt: 0.5,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        maxWidth: 280,
        borderRadius: '8px',
        borderColor: '#E2E8F0',
        backgroundColor: 'rgba(248, 250, 252, 0.8)',
        transition: 'border-color 0.15s ease',
        '&:hover': {
          borderColor: '#CBD5E1',
        },
      }}
    >
      {isImageType(mimeType) && fileUrl ? (
        <Box sx={{ width: '100%' }}>
          <Box
            component="img"
            src={fileUrl}
            alt={fileName}
            sx={{
              width: '100%',
              maxHeight: 160,
              objectFit: 'cover',
              borderRadius: '6px',
              mb: 0.5,
              cursor: 'pointer',
            }}
            onClick={() => window.open(fileUrl, '_blank')}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {getFileIcon(mimeType)}
            <Link
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              variant="caption"
              sx={{
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: '#1A73E8',
                fontWeight: 500,
              }}
            >
              {fileName}
            </Link>
            {fileSize && (
              <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                {formatFileSize(fileSize)}
              </Typography>
            )}
          </Box>
        </Box>
      ) : (
        <>
          {getFileIcon(mimeType)}
          <Box sx={{ flex: 1, overflow: 'hidden' }}>
            <Link
              href={fileUrl}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              variant="body2"
              sx={{
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: '#1A73E8',
                fontWeight: 500,
                fontSize: '0.82rem',
              }}
            >
              {fileName}
            </Link>
            {fileSize && (
              <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                {formatFileSize(fileSize)}
              </Typography>
            )}
          </Box>
        </>
      )}
    </Paper>
  );
};

export default ChatAttachment;
